document.addEventListener('DOMContentLoaded', function() {
    // Cibler les éléments contenant le prix avec "A partir de"
    var prices = document.querySelectorAll('.price-item--regular, .price-item--sale');

    prices.forEach(function(price) {
        price.innerHTML = price.innerHTML.replace(/A partir de\s*/gi, '');
    });
});
